(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Routing"));
	else if(typeof define === 'function' && define.amd)
		define(["Routing"], factory);
	else if(typeof exports === 'object')
		exports["tabId"] = factory(require("Routing"));
	else
		root["jQuery"] = root["jQuery"] || {}, root["jQuery"]["fn"] = root["jQuery"]["fn"] || {}, root["jQuery"]["fn"]["tabId"] = factory(root["Routing"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 